module.exports = __webpack_public_path__ + "img/whatsapp.0113c571.svg";